const pages = {
	sidebarMenu: [
		{
			title: 'Services',
			hasLink: 1,
			href: '/services',
			isTabLink: 0,
			hasTabs: 1,
			TabItems: [
				{
					title: 'ESSENTIALS',
					hasLink: 0,
					href: '',
					isTabLink: 1,
					hasTabs: 1,
					TabItems: [
						{
							title: 'Screening',
							hasLink: 1,
							href: '/services#ANCHOR_Services_Essentials',
							isTabLink: 1,
							hasTabs: 1,
							TabItems: [
								{
									title: 'Autism',
									hasLink: 1,
									href: '/services/diagnostics#ANCHOR_Diagnostics_Autism',
									isTabLink: 1,
									hasTabs: 0
								},
								{
									title: 'Functional Behavior',
									hasLink: 1,
									href: '/services/diagnostics#ANCHOR_Diagnostics_FuncBehavior',
									isTabLink: 1,
									hasTabs: 0
								},
								{
									title: 'Skill Deficit',
									hasLink: 1,
									href: '/services/diagnostics#ANCHOR_Diagnostics_SkillDef',
									isTabLink: 1,
									hasTabs: 0
								}
							]
						},
						{
							title: 'Therapies',
							hasLink: 1,
							href: '/services#ANCHOR_Services_Essentials',
							isTabLink: 1,
							hasTabs: 1,
							TabItems: [
								{
									title: 'ABA Therapy',
									hasLink: 1,
									href: '/services/therapy#ANCHOR_Therapy_ABATherapy',
									isTabLink: 1,
									hasTabs: 0
								},
								{
									title: 'Speech/Language Therapy',
									hasLink: 1,
									href: '/services/therapy#ANCHOR_Therapy_SpeechTherapy',
									isTabLink: 1,
									hasTabs: 0
								},
								{
									title: 'Occupational / Feeding Therapy',
									hasLink: 1,
									href: '/services/therapy#ANCHOR_Therapy_FeedingTherapy',
									isTabLink: 1,
									hasTabs: 0
								}
							]
						}
					]
				},

				{
					title: 'CARES',
					hasLink: 0,
					href: '',
					isTabLink: 1,
					hasTabs: 1,
					TabItems: [
						{
							title: 'ParentEd',
							hasLink: 1,
							href: '/services#ANCHOR_Services_Cares',
							isTabLink: 1,
							hasTabs: 1,
							TabItems: [
								{
									title: 'Community Sessions',
									hasLink: 1,
									href: '/services/parents#ANCHOR_ParentServices_ParentEd',
									isTabLink: 1,
									hasTabs: 0
								},
								{
									title: 'Community Events',
									hasLink: 1,
									href: '/services/parents#ANCHOR_ParentServices_Community',
									isTabLink: 1,
									hasTabs: 0
								}
							]
						},
						{
							title: 'Parent Support',
							hasLink: 1,
							href: '/services#ANCHOR_Services_Cares',
							isTabLink: 1,
							hasTabs: 1,
							TabItems: [
								{
									title: 'Coaching',
									hasLink: 1,
									href: '/services/parents#ANCHOR_ParentServices_Coach',
									isTabLink: 1,
									hasTabs: 0
								},
								{
									title: 'Nanny',
									hasLink: 1,
									href: '/services/parents#ANCHOR_ParentServices_Nanny',
									isTabLink: 1,
									hasTabs: 0
								}
							]
						}
					]
				}
			]
		},

		{
			title: 'FAQs',
			hasLink: 1,
			href: '/resources',
			isTabLink: 0,
			hasTabs: 0
		},
		{
			title: 'Resources',
			hasLink: 1,
			href: '/resources',
			isTabLink: 0,
			hasTabs: 0
		},
		{
			title: 'Contact Us',
			hasLink: 1,
			href: '/contact',
			isTabLink: 0,
			hasTabs: 0
		},
		{
			title: 'Careers',
			hasLink: 1,
			href: '/careers',
			isTabLink: 0,
			hasTabs: 0
		},
		{
			title: 'About Us',
			hasLink: 1,
			href: '/about',
			isTabLink: 0,
			hasTabs: 0
		}
	],

	linkTreeFLAT: [
		{
			title: 'Services',
			href: '/services'
		},
		{
			title: 'Diagnostic Services',
			href: '/services/diagnostics'
		},
		{
			title: 'Therapy Services',
			href: '/services/therapy'
		},
		{
			title: 'Parent Ed',
			href: '/services/parents'
		},
		{
			title: 'About Us',
			href: '/about'
		},
		{
			title: 'Contact Us',
			href: '/contact'
		},
		{
			title: 'Careers',
			href: '/careers'
		},
		{
			title: 'Resources',
			href: '/resources'
		},
		{
			title: 'Error 404: Cover',
			href: '/not-found-cover'
		}
	]
};

export default pages;
